// $(document).on('click', '#skip-upload', function() {
//         $('.ctm-product-form__submit').trigger('click'); 
//         $('.close_btn').trigger('click');
        
// });
document.getElementById('skip-upload').addEventListener('click', function() {
  


    if (!document.cookie.split('; ').find(row => row.startsWith('skipUpload='))) {
        console.log('JavaScript is running for the first time.');
        $('.ctm-product-form__submit').trigger('click'); 
        $('.close_btn').trigger('click');
         $('.close_btn_').trigger('click');
        document.cookie = "skipUpload=true; path=/; max-age=31536000"; // 1 year expiry
    } else {
        console.log('The JavaScript has already been executed.');
       $('.popup-container-1').css({
            'visibility': 'hidden',
            'opacity': '0',
            // 'transition': 'all 0.1s',
            'transform': 'scale(1.3)',
            'position': 'fixed'
        });
      $('.section-header.shopify-section-group-header-group').css({
                        'z-index': '3'
                    });
         $('body').css({
                        'overflow': 'auto'
                    });
      $('.ctm-product-form__submit').show(); 
       $('.ctm-add-to-cart-btn').hide(); 
       $('.ctm-product-form__submit').trigger('click'); 

         $('#custom_add_cart').hide();
    }
});
function removeSkipUploadCookie() {
    document.cookie = "skipUpload=; path=/; max-age=0"; // Expire the cookie immediately
}
$(document).on('click', '#upload-button_', function() {
        $('.close_btn_').trigger('click');
        $('#upload-file').trigger('click');
});
// js for color swaches
// money format


// Mandasa custom js

var checkedTitle = $('input[name="bundle_product"]:checked').val();
const checkedRadioButton = document.querySelector('input[name="bundle_product"]:checked');
    if (checkedRadioButton) {
      const selectedVarValue = checkedRadioButton.getAttribute('selected_var');
      const selected_varprice = checkedRadioButton.getAttribute('data_price');
      console.log('Selected Var Value:', selectedVarValue);
      console.log("okay");
      $(".product_list .option_name_heading .data-price").text(selected_varprice);
    }
$(".product_list .form__label .data-title").text(checkedTitle);

 $(document).on('change', 'input[name="bundle_product"]', function () {
    var selectedTitle = $(this).val();
    // alert("checking");
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    console.log(main_product_id);
      
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");

    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_first = document.querySelector('input[name="bundle_product_second"]:checked');
    const selected_varprice_first = checkedRadioButton_first?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_first?.getAttribute('data_co_price') || 0;

    const checkedRadioButton_sec = document.querySelector('input[name="bundle_product_third"]:checked');
    const selected_varprice_sec = checkedRadioButton_sec?.getAttribute('data_price') || 0;
    const selected_varCprice_sec = checkedRadioButton_sec?.getAttribute('data_co_price') || 0;

    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    console.log("selectedVariantCoPrice:", selectedVariantCoPrice);
    console.log("selected_varcp:", selected_varcp);
    console.log("selected_varCprice_first:", selected_varCprice_first);
    console.log("selected_varCprice_sec:", selected_varCprice_sec);

    function toFloat(value) {
        return parseFloat((value || "0").toString().replace(/[^0-9.\-]/g, "")) || 0;
    }

    var total_c_Price = 
        toFloat(selectedVariantCoPrice) + 
        toFloat(selected_varcp) + 
        toFloat(selected_varCprice_first) + 
        toFloat(selected_varCprice_sec);
    
    let updated_c_price = (total_c_Price / 100).toFixed(2);
    console.log(total_c_Price, "aaa");

     $(".compare_at_price_ctm").html(  updated_c_price + data_symbol);
     updateDiscountBadge();   

    if (selectedVariantPrice && selected_varp) { 
        var totalPrice = parseFloat(selectedVariantPrice) + parseFloat(selected_varprice_sec) + parseFloat(selected_varprice_first) + parseFloat(selected_varp);
        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
       $(".price_total").html( updated_price +  data_symbol );
   updateDiscountBadge();
    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
    $(this).closest(".product_list").find(".option_name_heading .data-price").html( selected_price + data_symbol );

    console.log(selected_var_id);
});

$('input[name="bundle_product_second"]').on('change', function () {
    var selectedTitle = $(this).val();
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_fi = document.querySelector('input[name="bundle_product"]:checked');
    const selected_varprice_fi = checkedRadioButton_fi?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_fi?.getAttribute('data_co_price') || 0;

    // Declare variables outside the if block
    let selected_varprice_s = 0;
    let selected_varCprice_sec = 0;

    const checkedRadioButton_s = document.querySelector('input[name="bundle_product_third"]:checked');
    if (checkedRadioButton_s) { 
        selected_varprice_s = checkedRadioButton_s.getAttribute('data_price') || 0;
        selected_varCprice_sec = checkedRadioButton_s.getAttribute('data_co_price') || 0;
    }

    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    console.log(selected_co_price + " fdf " + selected_varCprice_first + " dd " + selected_varCprice_sec);

    var totalPrice_compare = parseFloat(selected_varcp) + parseFloat(selectedVariantCoPrice) + parseFloat(selected_varCprice_first) + parseFloat(selected_varCprice_sec);
    let updated_c_price = (totalPrice_compare / 100).toFixed(2);
    console.log(updated_c_price, "checkifff");
     $(".compare_at_price_ctm").html( updated_c_price + data_symbol );
    updateDiscountBadge();

    if (selectedVariantPrice && selected_varp) { 
        var totalPrice = parseFloat(selectedVariantPrice) +  parseFloat(selected_varprice_fi) +  parseFloat(selected_varprice_s)  + parseFloat(selected_varp);
        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
         $(".price_total").html( updated_price  +  data_symbol );
   updateDiscountBadge();
    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
    $(this).closest(".product_list").find(".option_name_heading .data-price").html( selected_price + data_symbol );

    console.log(selected_var_id);
});

$('input[name="bundle_product_third"]').on('change', function () {
    var selectedTitle = $(this).val();
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    console.log(main_product_id);

    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");

    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_th = document.querySelector('input[name="bundle_product"]:checked');
    const selected_varprice_th = checkedRadioButton_th?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_th?.getAttribute('data_co_price') || 0;

    const checkedRadioButton_sth = document.querySelector('input[name="bundle_product_second"]:checked');
    const selected_varprice_sth = checkedRadioButton_sth?.getAttribute('data_price') || 0;
    const selected_varCprice_sec = checkedRadioButton_sth?.getAttribute('data_co_price') || 0;
 
    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    function toFloat(value) {
        return parseFloat((value || "0").toString().replace(/[^0-9.\-]/g, "")) || 0;
    }

    console.log("selected_co_price:", selected_co_price);
    console.log("selected_varCprice_first:", selected_varCprice_first);
    console.log("selected_varCprice_sec:", selected_varCprice_sec);

    var totalPrice_compare = 
        toFloat(selected_varcp) + 
        toFloat(selectedVariantCoPrice) + 
        toFloat(selected_varCprice_first) + 
        toFloat(selected_varCprice_sec);

    let updated_c_price = (totalPrice_compare / 100).toFixed(2);
    console.log(updated_c_price, "checkifff");
    $(".compare_at_price_ctm").html( updated_c_price + data_symbol);
updateDiscountBadge();

    if (selectedVariantPrice && selected_varp) {
        var totalPrice = 
            parseFloat(selectedVariantPrice) + 
            parseFloat(selected_varprice_th) + 
            parseFloat(selected_varprice_sth) + 
            parseFloat(selected_varp);

        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
        $(".price_total").html( updated_price +  data_symbol );
      updateDiscountBadge();

    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
     $(this).closest(".product_list").find(".option_name_heading .data-price").html( selected_price + data_symbol );

    console.log(selected_var_id);
});


function updateDiscountBadge() {
  let priceText = $(".price_total").text().replace(/[^\d.,]/g, '').replace(',', '.');
  let compareText = $(".compare_at_price_ctm").text().replace(/[^\d.,]/g, '').replace(',', '.');

  let price = parseFloat(priceText);
  let compare = parseFloat(compareText);

  if (!isNaN(price) && !isNaN(compare) && compare > price) {
    let discount = Math.round(((compare - price) / compare) * 100);
    $(".kav_price__badge-sale").html("Spare " + discount + "%").show();
  } else {
    $(".kav_price__badge-sale").hide();
  }
}


$(document).ready(function () {
    $('input[name="bundle_product"]:checked').trigger('change');
    $('input[name="bundle_product_second"]:checked').trigger('change');
    $('input[name="bundle_product_third"]:checked').trigger('change');
});

 var inputNameoption = 'options[' + optionLabelNamectm + ']';
  $(document).on('change', 'input[name="' + inputNameoption + '"]', function () {

  let selectedValue = $(this).val();
     let $this = $(this);
   var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
   var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
   let selectedVariantPrice_ = parseFloat((selectedVariantPrice / 100).toFixed(2));
    let data_symbol = $this.data('symbol');
    let data_code = $this.data('code');
    console.log(data_symbol, "selectedVariantPrice:", selectedVariantPrice_, data_code);
    $(this).closest("variant-selects").find(".data-price").html( selectedVariantPrice_ + data_symbol );
  // console.log('Selected Type:', selectedValue);
  // var all_html = $(".hide_mt").html();
  // $(".my-gallery .thumbnail-list__item").remove();
  $( ".my-gallery .thumbnail-list__item").each(function() {
        var our_ddvar = $(this).clone(); 
        // console.log(our_ddvar);
        var var_el3 = $(this).attr('data-alt');
          // console.log(var_el3);
         if(selectedValue == var_el3) {
           $(this).addClass('showing_images');
           // $(".my_gallery").append(our_ddvar);
           // $(our_ddvar).appendTo('.my-gallery');
           // $(".product-single__photo").show();
         }else{
            $(this).removeClass('showing_images');
         }
      });
      updateDiscountBadge();
});


  $(document).ready(function () {
  var inputName = 'options[' + optionLabelNamectm + ']';
    var $selectedInput = $('input[name="' + inputName + '"]:checked');
    console.log("inputName", inputName);
    
  var selectedValue = $selectedInput.val();
  if ($selectedInput.length > 0) {
    var $container = $(".product__info-container");
    var main_product_id = $container.find("#hidden-product-id").val();
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    let selectedVariantPrice_ = parseFloat((selectedVariantPrice / 100).toFixed(2));
    let data_symbol = $selectedInput.data('symbol');
    let data_code = $selectedInput.data('code');
    console.log(data_symbol, "selectedVariantPrice:", selectedVariantPrice_, data_code);
   $container.find(".option_name_type .data-price").html( selectedVariantPrice_ + data_symbol);
    $(".my-gallery .thumbnail-list__item").each(function (index) {
      var $thumb = $(this);
      var var_el3 = $thumb.attr('data-alt');

      if (var_el3 === '') {
        $thumb.addClass('showing_images');
      } else if (selectedValue === var_el3) {
        $thumb.addClass('showing_images');
      }
    });
   updateDiscountBadge();
  } else {
    console.warn("No Armband option is selected.");
  }
});



/********************** product details page photo upload personalization start ************************/

let personalizeData = [];
let doubleJoyData=[];
jQuery(document).on("click",".upload .btn__file-picker.default-file-picker",function(){
    var colorSelected='';
    var getImageVariant='';
     var fileInput = jQuery(this);
    if(jQuery('[name="Farbe"]').length!=0){
      if(colorSelected!=undefined && colorSelected!=null){
        colorSelected = jQuery('[name="Farbe"]:checked').val();
        getImageVariant = jQuery('[name="Farbe"]:checked').attr("swatch-image");
      }
    }else if(jQuery('[name="options[Farbe]"]').length!=0){
       colorSelected = jQuery('[name="options[Farbe]"] option:selected').val();
       getImageVariant = jQuery('[name="options[Farbe]"] option:selected').attr("swatch-image");
    }
    var variantId = jQuery('.product-variant-id').val();
    console.log("variantId", variantId);
    //var getImageVariant = jQuery('.thumbnail-slider_mt').find('.thumbnail-list_item--variant img').attr("src");
    jQuery('.modal__centered-content').find('.modal-image').attr("src",getImageVariant);
    jQuery('.modal__centered-content').find('.modal-image img').attr("src",getImageVariant);
    var cropImage = '';
    var finalImage = '';
    jQuery('body').addClass('upload-popup-hidden');
    if(jQuery(this).hasClass("funnelversion-two")){
      jQuery('.first-step-button').hide();
      jQuery('.funnel-button-section').show();
      personalizeData.push({});
      var interval=setInterval(function(){
        cropImage=jQuery('.modal--upload.popup-container-funnel.active').find('#inline-editor-3').attr("crop-image");
        if(cropImage!=undefined){
          clearInterval(interval);
          personalizeData[0]['crop_image']=cropImage;
        }
      },100);
      var interval1 = setInterval(function(){
        finalImage=jQuery('.modal--upload.popup-container-funnel.active').find('#inline-editor-3').attr("blob-url");
        if(finalImage!=undefined){
          clearInterval(interval1);
          var colorValue = formatString(colorSelected);
          setTimeout(function(){
            var mergeImage = window.createOverlapingImage(getImageVariant,finalImage,'',colorValue);
              mergeImage.then(function(value) {
                console.log("mergeImage",mergeImage);
                personalizeData[0]['final_image']=value;
              }).catch(function(error) {
                  console.error('Error:', error);
              });
          },700)
        }
      },1000);
      personalizeData[0]['color']=colorSelected;
      personalizeData[0]['id']=variantId;
      personalizeData[0]['data_repeat']=0;
      personalizeData[0]['variant_image']=getImageVariant;
    }else{
      setTimeout(function(){
      // alert("not working");

        jQuery('.modal--upload.active').find('.step-1.common-steps').show();
        cropImage=jQuery('.modal--upload.active').find('#inline-editor-1').attr("crop-image");
        jQuery('.funnel-button-section').hide();
        jQuery('.first-step-button').show();
        console.log("else cropImage",cropImage,variantId);
        personalizeData.push({
          color:colorSelected,
          id:variantId,
          data_repeat:0,
          crop_image:cropImage,
          variant_image:getImageVariant
        });
      },100);
    }
    //console.log("cropImage",cropImage);   
     
});

jQuery(document).on("click",".modal--upload.active .edit_bracelet",function(){
  var getIndex = jQuery(this).attr('data-edit');
  editFunnelFirst(getIndex);
});

jQuery(document).on("click",".modal--upload.active .color-variant.product-variant",function(){
  var colorSelected=jQuery(this).attr("data-color");
  var colorValue = jQuery(this).attr("data-value");
  var variantId=jQuery(this).attr("data-vid");
  var variantImg=jQuery(this).find('img').attr("src");
  if(jQuery(this).parent().parent('div').find(".color-variant.product-variant.active").length!=0){
    var removeVariantID = jQuery(this).parent().parent('div').find(".color-variant.product-variant.active").attr("data-vid");
    jQuery('.main-custom-engraving.engraving-section-'+removeVariantID).addClass("engraving-section-"+variantId);
    jQuery('.main-custom-engraving').removeClass("engraving-section-"+removeVariantID);
  }
  jQuery('.engraving-section-'+variantId).find('.switch-funnel-joy').attr('data-vid',variantId);
  jQuery('#merge-editor img').attr("src",variantImg);
  jQuery(this).parent().parent('div').find(".color-variant.product-variant").removeClass("active");
  var blobUrl = jQuery(this).parent().parent('div').prev('.upload-bracelet-photo').find('.inline-editor').attr('blob-url');
  var cropImage = jQuery(this).parent().parent('div').prev('.upload-bracelet-photo').find('.inline-editor').attr('crop-image');
  //console.log("cropImage",cropImage);
  jQuery(this).addClass("active");
  if(jQuery(this).parent().parent('div').hasClass("funnel-repeat")){
    var repeatId = jQuery(this).parent().parent('div').attr("data-repeat");
    //console.log("repeatId sl",repeatId);
    if(repeatId!=undefined){
      repeatId = parseInt(repeatId);
      var checkval = checkKeyValue(personalizeData,'data_repeat',repeatId);
      var lengthRemove = jQuery("#delete_count").val();
      if(lengthRemove>0){
        lengthRemove = parseInt(lengthRemove);
        checkval=(parseInt(repeatId)-lengthRemove);
      }
      //console.log("checkval",checkval);
      if(checkval>=0){
        if(personalizeData[checkval]!=undefined){
          personalizeData[checkval].id=variantId;
          personalizeData[checkval].variant_image=variantImg;
          personalizeData[checkval].data_repeat=parseInt(checkval);
          personalizeData[checkval].color=colorSelected;
          personalizeData[checkval].crop_image=cropImage;
          //if(personalizeData[checkval].upload_image!=undefined){
            setTimeout(function(){
            var mergeImage = window.createOverlapingImage(variantImg,blobUrl,'',colorValue);
              mergeImage.then(function(value) {
                //console.log("mergeImage set img",mergeImage);
                personalizeData[checkval].final_image=value;
              }).catch(function(error) {
                  //console.error('Error:', error);
              });
            },500);
          //}
        }
      }else{
        personalizeData.push({
          id:variantId,
          data_repeat:parseInt(checkval),
          color:colorSelected,
          crop_image:cropImage
        });
        if(checkval!=undefined){
          checkval = parseInt(checkval);
          if(personalizeData[checkval].upload_image!=undefined){
            setTimeout(function(){
            var mergeImage = window.createOverlapingImage(variantImg,blobUrl,'',colorValue);
              mergeImage.then(function(value) {
                //console.log("mergeImage",mergeImage);
                personalizeData[checkval].final_image=value;
              }).catch(function(error) {
                  console.error('Error:', error);
              });
            },500);
          }
        }
      }
      jQuery(".select-bracelet-color.funnel-repeat[data-repeat='"+repeatId+"']").find(".color-variant.product-variant").removeClass("active");
      jQuery(".select-bracelet-color.funnel-repeat[data-repeat='"+repeatId+"']").find(".color-variant.product-variant[data-vid='"+variantId+"']").addClass("active");
      //console.log("personalizeData sl",personalizeData);
    }
  }
});

/*function checkKeyValue(data,keycheck,valuecheck){
    let found = data.some(function(item) {
        return item[keycheck] === valuecheck; // Check if the key-value pair matches
    });
    return found;
}*/
function checkKeyValue(data, keyCheck, valueCheck) {
    for (let i = 0; i < data.length; i++) {
        if (data[i][keyCheck] === valueCheck) {
            return i; // Return the index when the key-value pair matches
        }
    }
    return -1;
}


jQuery(document).on("change",".switch-funnel-joy",function(){
  var variantId = jQuery(this).attr("data-vid");
  //jQuery(".main-custom-engraving.engraving-section-"+variantId).find('.engraving-text').show();
  if(jQuery(this).is(":checked")){
    jQuery(this).parent().parent().parent().parent().parent('div').find('.engraving-text').show();
  }else{
    jQuery(this).parent().parent().parent().parent().parent('div').find('.engraving-text').hide();
  }
});

jQuery(document).on("click",".steps-next-btn",function(){
  var steps = jQuery(this).attr("steps");
  // jQuery(this).removeClass("hide");
  jQuery(this).addClass('loading');
  jQuery(this).find('.loading__spinner').removeClass('hidden');
 
  if(steps==1 && jQuery(this).hasClass("first-step-button") && jQuery(this).hasClass("active-editmode")==false){
    var lengthKey = (personalizeData.length-1);
    var blobUrl = jQuery('.modal--upload.active').find('.inline-editor').attr("data-src");
    var default_image = jQuery('.modal--upload.active').find('.inline-editor').attr("main-img");
    //var uploadeImg = blobToCloudinaryupload(blobUrl);
    
    const staticImageUrl = jQuery('#merge-editor img').attr("src");
    var colorValue = jQuery('[name="options[Farbe]"] option:selected').attr('data-value');
    var cpInter=setInterval(function(){
      var cropImage = jQuery('.modal--upload.active').find('.inline-editor').attr("crop-image");
      if(cropImage!=undefined){
       personalizeData[0].crop_image=cropImage;
      }
    },100);
    setTimeout(function(){
      var cropImage = jQuery('.modal--upload.active').find('.inline-editor').attr("crop-image");
      var mergeImage = window.createOverlapingImage(staticImageUrl,blobUrl,'',colorValue);
      mergeImage.then(function(value) {
          personalizeData[0].final_image=value;
          jQuery('#merge-editor img').attr("src", value);
          var editorElement = jQuery('#merge-editor img');
          setTimeout(() => {
              editorElement[0].offsetHeight; // Trigger reflow
          }, 300);

      }).catch(function(error) {
          //console.error('Error:', error);
      });
      personalizeData[0].upload_image=blobUrl;
      personalizeData[0].crop_image=cropImage;
      personalizeData[0].default_image=default_image;
      nextstepwiseShow(steps,cpInter);
      jQuery('.editorLoading.custom-loading').removeClass("hide");
    },100);
   
  }
  else{
    //console.log("personalizeData",personalizeData);
    var editId = jQuery(this).attr('data-edit');
    //console.log("editId",editId);
    if(editId!=undefined && steps==1){
      var lengthRemove = jQuery("#delete_count").val();
      if(lengthRemove>0 && editId>=1){
        lengthRemove = parseInt(lengthRemove);
        editId = (parseInt(editId)-lengthRemove);
      }
      var lengthKey = (personalizeData.length-1);
      var blobUrl = jQuery('.modal--upload.active').find('.inline-editor').attr("data-src");
      var default_image = jQuery('.modal--upload.active').find('.inline-editor').attr("main-img");
      
      //var uploadeImg = blobToCloudinaryupload(blobUrl);
      const staticImageUrl = jQuery('#merge-editor img').attr("src");
      var colorValue = personalizeData[editId].color;
      var cpInter=setInterval(function(){
        var cropImage = jQuery('.modal--upload.active').find('.inline-editor').attr("crop-image");
        if(cropImage!=undefined){
         personalizeData[editId].crop_image=cropImage;
        }
      },500);
      setTimeout(function(){
        var mergeImage = window.createOverlapingImage(staticImageUrl,blobUrl,'',colorValue);
        mergeImage.then(function(value) {
            personalizeData[editId].final_image=value;
        }).catch(function(error) {
            //console.error('Error:', error);
        });
        jQuery('.custom-loading').addClass("hide");
        nextstepwiseShow(steps,cpInter);
      },100);
     
    }else{
      if(jQuery('.modal--upload.active .switch-landing-noreverse').is(":checked")){
        if(jQuery('.modal--upload.active [name="engraving_text"]').val()!=""){
          jQuery('.custom-loading').addClass("hide");
          jQuery(this).next('.error-msg').hide();
          nextstepwiseShow(steps);
        }else{
          //jQuery('.modal--upload.active').find('.modal__centered').removeClass('modal__loader');
          jQuery('.custom-loading').addClass("hide");
          jQuery(this).next('.error-msg').show();
        }
      }else{
        nextstepwiseShow(steps);
      }
    }
  }
  $(".common-steps").show();
  //console.log("personalizeData",personalizeData);
});

jQuery(document).on("click",".addmore_bracelet",function(e){
  //console.log("auto triger");
    var autoIds = jQuery('.modal--upload.active').find('.addmore-data-append').find('.second-bracelet-name-image:last').attr('id');
    autoIds = autoIds.replace('bracelet_','');
    autoIds = parseInt(autoIds);
    var htmlString1 = jQuery(".product__info-container").find(".funnel-add-morehtml").html(); 
    var htmlObject = jQuery(htmlString1); // Convert HTML string to a jQuery object
  
    var upindex = 2;
    upindex+=jQuery(".modal--upload.active").find('.second-bracelet-name-image').length;
  
    var filePicker = htmlObject.find('.btn__file-picker.upload-file');
    htmlObject.find('.main-modal-product').hide();
    htmlObject.find('.engraving-text').hide();
    var autoIdFile = 0; // Initialize ID counter if not defined earlier
    if (filePicker.length) {
        autoIdFile = parseInt(upindex); // Increment the `data-id`
        filePicker.attr("data-id", autoIdFile).attr("id", "upload-file-" + autoIdFile);
    }

    var inlineEditor = htmlObject.find('.inline-editor.joy-add-editor');
    if (inlineEditor.length) {
      inlineEditor.attr("id", "inline-editor-" + autoIdFile);
      inlineEditor.attr('data-src','');
      inlineEditor.attr('main-img','');
      inlineEditor.attr('crop-image','');
      inlineEditor.attr('blob-url','');
    }
    
    var newBraceletWrapper = jQuery('<div class="second-bracelet-name-image" id="bracelet_'+upindex+'"></div>').append(htmlObject);
    jQuery('.modal--upload.active').find('.addmore-data-append').append(newBraceletWrapper);
    jQuery('#inline-editor-' + autoIdFile).empty();
    jQuery("#upload-file-" + autoIdFile).parent('div').show();
  
    var funnelRepeat = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.select-bracelet-color.funnel-repeat');
    //console.log("funnelRepeat after add",funnelRepeat);
    var indexUp=1;
    
    if(funnelRepeat.length!=0){
      if(jQuery(".modal--upload.active").find('.second-bracelet-name-image').length>0){
        indexUp+=jQuery(".modal--upload.active").find('.second-bracelet-name-image').length;
      }
      getIndex = parseInt(indexUp);
      //console.log("getIndex after add",getIndex);
      funnelRepeat.attr("data-repeat",getIndex);
      funnelRepeat.find('.color-variant.product-variant').removeClass('active');
      funnelRepeat.find('.color-variant.product-variant').eq(0).addClass('active');
    }
    
    jQuery('#bracelet_'+autoIdFile).find('.bracelet-image-text').hide();

    var editBracelet = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.edit_bracelet');
    if (editBracelet.length) {
        editBracelet.attr("id",'edit_'+getIndex);
        editBracelet.attr("data-edit",getIndex);
    }

    var deleteBracelet = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.delete_bracelet');
    if (deleteBracelet.length) {
        deleteBracelet.attr("id",'deletefunnel_'+getIndex);
        deleteBracelet.attr("funnel-delete",getIndex);
        deleteBracelet.attr("data-main",autoIdFile);
    }

    var mainIndex=parseInt(upindex);
    var changeIndex = (parseInt(upindex-1));
    if(changeIndex==2){
      changeIndex = 1;
    }
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.edit_bracelet').show();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.bracelet-image-text').show();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.upload-bracelet-photo').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.select-bracelet-color.funnel-repeat').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.main-custom-engraving').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.edit_bracelet').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.bracelet-image-text').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.upload-bracelet-photo').show();
    jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.select-bracelet-color.funnel-repeat').show();
    jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.main-custom-engraving').show();

    var countBracelet = jQuery(".modal--upload.active").find('#bracelet_'+upindex).find('.bracelet-name .number');
    if (countBracelet.length) {
        jQuery(".modal--upload.active").find('#bracelet_'+upindex).find('.bracelet-name .number').attr("data-count",upindex);
        var countBraceletName = jQuery(".modal--upload.active").find('#bracelet_'+mainIndex).find('.bracelet-name .name');
        if (countBraceletName.length) {
            var suffix = getOrdinalSuffix(upindex); // Get suffix (st, nd, rd, th)
            countBraceletName.text(upindex + suffix + ' Bracelet'); // Update name with suffix
            var numberSet=upindex;
            if(upindex<10){
              numberSet='0'+upindex;
            }
            jQuery(".modal--upload.active").find('#bracelet_'+upindex).find('.bracelet-name .number').text(numberSet);
        }
    }
  
    jQuery('.step-4.common-steps').find('#add-to-fourth-cart').hide();
    jQuery('.step-4.common-steps').find('#add-to-order').hide();
    jQuery('.step-4.common-steps').find('.addmore-sectionlink').hide();
    jQuery('.step-4.common-steps').find('#add-to-fourth-cart').show();
    jQuery('#add_moredata').val(1);
    e.preventDefault();
    e.stopPropagation();
});

function formatString(inputString) {
  // Convert to lowercase
  var formattedString = inputString.toLowerCase();

  // Replace spaces with underscores
  formattedString = formattedString.replace(/ /g, '_');

  // Remove specific special characters
  formattedString = formattedString.replace(/[!@#]/g, '');

  // Replace multiple underscores with a single underscore
  formattedString = formattedString.replace(/__+/g, '_');

  // Trim leading and trailing underscores (optional)
  formattedString = formattedString.replace(/^_+|_+$/g, '');

  return formattedString;
}

jQuery(document).on("click",".modal--upload.active .modal__centered-content .double-joy",function(){
  loaderShowHide();
  var steps = jQuery(this).attr("steps");
  nextstepwiseShow(steps);
  if(personalizeData.length>0){
    var pl=0;
    var countedit=0;
    jQuery.each(personalizeData, function(index, value) {
      var idMainDiv = jQuery('.bracelet-text').eq(index).parent().parent().parent('div').attr("id");
      if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
        idMainDiv = idMainDiv.replace("bracelet_","braceletfunnel_");
      }
      //console.log("idMainDiv",idMainDiv);
      var engravingset=value.engravingtext;
      var colorselect=value.color;
      var addgifttitle=value.giftcard_title;
      var overlapImg = value.final_image;
      var variantImg = value.variant_image;
      var variantId = value.variant_id;
      //console.log("overlapImg joy data",overlapImg)
      var colorValue = formatString(colorselect);
      //console.log("colorValue",colorValue);
      jQuery('.bracelet-text').eq(index).parent('div').show();
      if(jQuery('.modal--upload.popup-container-funnel.active').length==0){
        var htmlobj = jQuery('.modal--upload.active').find('.first-bracelet-name-image').eq(pl);
        if(index>0){
          if(index==1){
            pl=0;
          }
          htmlobj = jQuery('.modal--upload.active').find('.second-bracelet-name-image:not(".remove-bracelet")').eq(pl);
        }
      
        htmlobj.find('.bracelet-image-text .bracelet-photo img').attr("src",overlapImg);
        htmlobj.find('.bracelet-image-text .engrave-text').text(engravingset);
        htmlobj.find('.bracelet-image-text .selected-color').text(colorselect);
        htmlobj.find('.bracelet-image-text .selected-giftcard').html(addgifttitle);
        htmlobj.find('.bracelet-image-text .bracelet-color-image img').attr('src',variantImg);
      }else{
        //console.log("idMainDiv",idMainDiv);
        var blobUrl = jQuery('#'+idMainDiv).find('.inline-editor').attr('blob-url');
        if(blobUrl==undefined){
          blobUrl = jQuery('#inline-editor-3').attr('blob-url');
        }
        jQuery('.custom-loading').removeClass("hide");
        setTimeout(function(){
          //console.log("blobUrl",blobUrl);
          var mergeImage = window.createOverlapingImage(variantImg,blobUrl,'',colorValue);
          mergeImage.then(function(value) {
              jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-photo img').attr("src",value);
              jQuery('.custom-loading').addClass("hide");
          }).catch(function(error) {
              console.error('Error:', error);
          });
          
        },500);
        //jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-photo img').attr("src",variantImg);
        jQuery('#'+idMainDiv).find('.bracelet-image-text .engrave-text').eq(index).text(engravingset);
        jQuery('#'+idMainDiv).find('.bracelet-image-text .selected-color').eq(index).text(colorselect);
        jQuery('#'+idMainDiv).find('.bracelet-image-text .selected-giftcard').eq(index).html(addgifttitle);
        jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-color-image img').attr('src',variantImg);
      }
      pl++;
      if(idMainDiv!='bracelet_0' && idMainDiv!="braceletfunnel_0"){
        jQuery('#'+idMainDiv).find('.engraving_text_common').val(engravingset);
      }
      if(countedit!=0){
        jQuery('.addmore-data-append').find('.bracelet-edit').show();
      }
      jQuery('.addmore-data-append').find('.select-bracelet-color').find('.color-variant.product-variant').eq(0).addClass('active');
      countedit++;
    });
  }
  loaderShowHide();
  if(jQuery(this).hasClass('funnel-addmore')){
    jQuery('.modal--upload.active').find('.steps-next-btn.first-step-button').removeClass("active-editmode");
    jQuery('.modal--upload.active').find('.steps-next-btn.first-step-button').removeAttr("data-edit");
    if(jQuery('.modal--upload.active').find('.second-bracelet-name-image:last').length>1 || jQuery('.modal--upload.active').find('.second-bracelet-name-image:last').find('.inline-editor.joy-add-editor').html()!=""){
      //console.log("more vals",jQuery('#add_moredata').val());
      if(jQuery('#add_moredata').val()==0){
        addMoreBracelet();
      }else{
        jQuery('.addmore_bracelet').trigger("click");
      }
    }
  }
});

jQuery(document).on("keyup",".custom-text-input #engraving_text",function(){
  if(jQuery(this).val()!=""){
    var getIndex = jQuery(this).parent().parent().parent().parent('div').find(".funnel-repeat").attr("data-repeat");
    if(jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button').hasClass('active-editmode')){
      getIndex = jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button.active-editmode').attr("data-edit");
    }
    if(getIndex==undefined){
      getIndex=0;
    }
    getIndex = parseInt(getIndex);
    var getkey = checkKeyValue(personalizeData,'data_repeat',getIndex);
    if(getkey<0 || getkey==""){
      getkey = 0;
    }
    personalizeData[getkey].engravingtext=jQuery(this).val();
    jQuery('.engraving_textpreview').text(jQuery(this).val());
  }
});

jQuery(document).on("click", ".modal--upload.active .modal-product-card.gift-card-products", function() {
  if (jQuery(this).hasClass('funnel-gift-boxs')) {
    // Remove active class only from funnel gift boxes
    jQuery('.modal--upload.active .modal-product-card.gift-card-products.funnel-gift-boxs').removeClass('active-card');
  } else {
    // Remove active class only from regular gift cards
    jQuery('.modal--upload.active .modal-product-card.gift-card-products:not(.funnel-gift-boxs)').removeClass('active-card');
  }

  jQuery(this).addClass('active-card'); // Add active class to clicked card

  var repeatId = '';
  if (jQuery('.modal--upload.popup-container-funnel.active').length > 0) {
    repeatId = jQuery(this).closest('div').find(".select-bracelet-color.funnel-repeat").attr("data-repeat") || 0;
  }

  giftCardSelected(repeatId);
});



function loaderShowHide(){
  if(jQuery('.custom-loading').hasClass("hide")){
    jQuery('.custom-loading').removeClass("hide");
  }else{
    jQuery('.custom-loading').addClass("hide");
  }
  setTimeout(function(){
    jQuery('.custom-loading').addClass("hide");
  },1000);
}

jQuery(document).on("click",".backsteps-button",function(){
  var getStep = jQuery(this).attr("data-step");
  
  if(jQuery(this).hasClass('back-repeat')){
    getStep=4;
  }
  previousSteps(getStep);
});

var currentStepIndex = 0;
function previousSteps(step){
  const modal = jQuery('.modal--upload.active');
  console.log(step, "checking");

  loaderShowHide();

  setTimeout(function(){
   
    var $currentDot = $('.modal-header-dot.active');
    var $prevDot = $currentDot.prev('.modal-header-dot');
    if ($prevDot.length) {
      $currentDot.removeClass('active');
      $prevDot.addClass('active');
    }
    // Handle common-steps_
    var $currentStep = $('.common-steps_.active');
    var $prevStep = $currentStep.prev('.common-steps_');
    var $currentStep = $('.common-steps_.active');
    var $steps = $('.common-steps_');
  var $currentStep = $steps.eq(currentStepIndex);
  var $nextStep = $steps.eq(currentStepIndex + 1);
if (currentStepIndex > 0) {
    $steps.eq(currentStepIndex).removeClass('active');
      currentStepIndex--; // Decrease index
      // Show previous step
      $steps.eq(currentStepIndex).addClass('active');

      // Slide effect using transform
      $('.common-steps').css({ // Wrapper should be a parent div containing .common-steps_
        'transform': 'translateX(-' + (currentStepIndex * 100) + '%)',
        'transition': 'transform 0.5s ease'
      });
  }
  
     if ($('.step-3').hasClass('active')) {
        $('.step-3').closest('.modal__centered-content').addClass('new-class');
      } else {
        $('.step-3').closest('.modal__centered-content').removeClass('new-class');
      }
    loaderShowHide();
  }, 200);

  if(step == 2){
    modal.find('.modal__centered').addClass('scroll-modal');
    const modalBody = modal.find('.modal__centered-content');
    if(modalBody.length){
      modalBody.animate({
        scrollTop: modalBody.height()
      }, 500);
    }
  } else {
    modal.find('.modal__centered').removeClass('scroll-modal');
  }
}

function selectedDataFunnel2(){
  loaderShowHide();
  if(personalizeData.length>0){
    jQuery.each(personalizeData, function(index, value) {
      var idMainDiv = jQuery('.common-section-funnel:not(".remove-bracelet")').eq(index).attr("id");
      var engravingset=value.engravingtext;
      var colorselect=value.color;
      var addgifttitle=value.giftcard_title;
      var overlapImg = value.final_image;
      var variantImg = value.variant_image;
      var uploadImage = value.upload_image;
      var variantId = value.variant_id;
      var colorValue = formatString(colorselect);
      //console.log("idMainDiv funnul2",idMainDiv,overlapImg);
      jQuery('#'+idMainDiv).find('.bracelet-text').parent('div').show();
      jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-photo img').attr("src",overlapImg);
      //jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-photo').find('img').attr("src",variantImg);
      jQuery('#'+idMainDiv).find('.bracelet-image-text .engrave-text').text(engravingset);
      jQuery('#'+idMainDiv).find('.bracelet-image-text .selected-color').text(colorselect);
      jQuery('#'+idMainDiv).find('.bracelet-image-text .selected-giftcard').html(addgifttitle);
      jQuery('#'+idMainDiv).find('.bracelet-image-text .bracelet-color-image img').attr('src',variantImg);
      if(idMainDiv!="braceletfunnel_0"){
        jQuery('#'+idMainDiv).find('.engraving_text_common').val(engravingset);
      }
    });
  }
  loaderShowHide();
}

window.giftCardSelected = function(repeatId=""){
  var productGift=[];
  var productGiftTitle='';
  //console.log("lenght",jQuery('.modal--upload.active').find('.gift-card-products.active-card').length);
  if(jQuery('.modal--upload.active').find('.gift-card-products.active-card').length>0){
    jQuery('.modal--upload.active').find('.gift-card-products.active-card').each(function(){
      var variantId = jQuery(this).attr("data-vid");
      var productTitle = jQuery(this).attr("data-vtitle");
      productGift.push(variantId);
      productGiftTitle+='<li>'+productTitle+'</li><hr class="add-on-line">';
    });
  }
  //console.log("personalizeData gift",personalizeData);
  var getKey = 0;
  if(personalizeData.length>0){
    getKey = (personalizeData.length-1);
  }
  if(jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button').hasClass('active-editmode')){
    getKey = jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button.active-editmode').attr("data-edit");
  }
  
  var lengthRemove = jQuery("#delete_count").val();
  lengthRemove = parseInt(lengthRemove);
  //console.log("lengthRemove",lengthRemove);
  if(lengthRemove>0){
    if(repeatId!=""){
      getKey = (parseInt(repeatId)-lengthRemove);
    }else{
      getKey = (parseInt(personalizeData.length)-lengthRemove);
    }
  }
 
  if(productGift.length>0){
    if(personalizeData[getKey]!=undefined){
      personalizeData[getKey].giftcard_product=productGift;
      var newStr = productGiftTitle.slice(0, -1)
      personalizeData[getKey].giftcard_title=newStr;
    }
  }
  //console.log("personalizeData gift card",personalizeData);
}

// if (jQuery('body').hasClass('different-shape')) {

// } else {

  jQuery(document).on("click","#add-to-cart,#funnel-btn-cart,#add-to-fourth-cart",function(){
    jQuery("#add-to-cart").addClass('loading');

      jQuery("#add-to-cart").find('.loading__spinner').removeClass('hidden');

    if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
      
      if(jQuery('.modal--upload.popup-container-funnel.active .funnel-engrave-text').is(":checked")){
        if(jQuery('.modal--upload.active').find('.funnel-step-2').find('[name="engraving_text"]').val()!=""){
          loaderShowHide();
          addToCart();
          jQuery('.modal--upload.popup-container-funnel.active').find('.error-msg').hide();
        }else{
          jQuery('.modal--upload.popup-container-funnel.active').find('.error-msg').show();
        }
      }else{
        loaderShowHide();
        addToCart();
        jQuery('.modal--upload.popup-container-funnel.active').find('.error-msg').hide();
      }
    }else{
      loaderShowHide();
      addToCart();
    }
  });

// }

jQuery(document).on("click","#add-to-order",function(){
  if(jQuery(".modal--upload.active .second-bracelet-name-image:not('.remove-bracelet')").length>0){
    loaderShowHide();
    jQuery('.modal--upload.active').find('.step-3.common-steps').show();
    jQuery('.modal--upload.active').find('.step-3.common-steps').addClass("funnel-repeat");
    jQuery('.modal--upload.active').find('.step-3.common-steps').find('.backsteps-button.action-section').addClass('back-repeat');
    //jQuery('.modal--upload.active').find('.step-2.common-steps .select-bracelet-color').show();
    jQuery('.modal--upload.active').find('.step-3.common-steps .modal-product-card.gift-card-products').removeClass("active-card");
    
    jQuery('.modal--upload.active').find('.step-4.common-steps').hide();
    jQuery('.modal--upload.active').find('#add-to-order').removeClass("addmore-active");
    loaderShowHide();
    var repeatId = jQuery('.modal--upload.active').find('.step-4.common-steps .second-bracelet-name-image:last').find('.select-bracelet-color.funnel-repeat').attr("data-repeat");
    //console.log("repeatId",repeatId);
    repeatId = parseInt(repeatId);
    var checkval = checkKeyValue(personalizeData,'data_repeat',repeatId);
    var cropImage = jQuery('.modal--upload.active').find('.step-4.common-steps .second-bracelet-name-image:last').find('[data-repeat="'+repeatId+'"]').parent('div').find('.inline-editor').attr("crop-image");
    var blobUrl = jQuery('.modal--upload.active').find('.step-4.common-steps .second-bracelet-name-image:last').find('[data-repeat="'+repeatId+'"]').parent('div').find('.inline-editor').attr("data-src");
    //var uploadeImg = blobToCloudinaryupload(blobUrl);
    var colorValue = jQuery('.modal--upload.active').find('.step-4.common-steps .second-bracelet-name-image:last').find('[data-repeat="'+repeatId+'"]').find('.color-variant.product-variant.active').attr('data-value');
    const staticImageUrl = jQuery('#merge-editor img').attr("src");
    var lengthRemove = jQuery("#delete_count").val();
    if(lengthRemove>0){
      lengthRemove = parseInt(lengthRemove);
      checkval = (parseInt(repeatId)-lengthRemove);
    }
   
    if(jQuery(this).parent().parent('div').find('.select-bracelet-color').hasClass("funnel-repeat")){
      if(checkval>0){
        setTimeout(function(){
          jQuery('.custom-loading').removeClass("hide");
          var mergeImage = window.createOverlapingImage(staticImageUrl,blobUrl,1,colorValue);
          mergeImage.then(function(value) {
              personalizeData[checkval].final_image=value;
             jQuery('.custom-loading').addClass("hide");
          }).catch(function(error) {
              console.error('Error:', error);
          });
          personalizeData[checkval].crop_image=cropImage;
        },600);
      }else{
        personalizeData.push({
          id:variantId,
          data_repeat:parseInt(repeatId),
          crop_image:cropImage,
        });
        var checkval = checkKeyValue(personalizeData,'data_repeat',repeatId);
        jQuery('.custom-loading').removeClass("hide");
        setTimeout(function(){
          var mergeImage = window.createOverlapingImage(staticImageUrl,blobUrl,1,colorValue);
          mergeImage.then(function(value) {
              personalizeData[checkval].final_image=value;
            jQuery('.custom-loading').addClass("hide");
          }).catch(function(error) {
              console.error('Error:', error);
          });
        },600);
        console.log("else data",personalizeData);
      }
    }
    //console.log("add order",personalizeData);
  }else{
    addMoreBracelet();
  }
  //jQuery('.double-add-bracelet').hide();
});

jQuery(document).on("click","#add-to-order-funnel",function(){
  prepareDoubleJoyData();
  loaderShowHide();
});

function prepareDoubleJoyData(){
  var getTotalActive = jQuery('.modal--upload.active').find('.product-variant.active').length;
  var activeCount = 0;

  setTimeout(function(){
    addToCart();
  },1000);
   
}

let cartDrawerObject =  document.querySelector('cart-drawer');
function addToCart(){
  var cartObject = [];
  jQuery.each(personalizeData,function(index,personalize){
    var propertiesdata = {};
    if(jQuery('.modal--upload.active').find('.bundle--checkbox.engraving-common-funnel').is(":checked")){
      if(personalize.engravingtext!=undefined && personalize.engravingtext!=""){
        propertiesdata['__engraving_text']=personalize.engravingtext;
      }
    }
    if(personalize.crop_image!=undefined && personalize.crop_image!=""){
      propertiesdata['Dein Foto']=personalize.crop_image;
      cartObject.push({ 
        id: personalize.id,
        quantity: 1,
        properties:propertiesdata
      });
    }else if(jQuery('.modal--upload.active').find('#inline-editor-1').length>0){
      if(jQuery('.modal--upload.active').find('#inline-editor-1').attr('crop-image')!=""){
        propertiesdata['Dein Foto']=jQuery('.modal--upload.active').find('#inline-editor-1').attr('crop-image');
        cartObject.push({ 
          id: personalize.id,
          quantity: 1,
          properties:propertiesdata
        });
      }
    }
    if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
      if(jQuery('.modal--upload.popup-container-funnel.active').find('.gift-card-products.active-card').length>0){
        if(personalize.giftcard_product!=undefined && personalize.giftcard_product!=""){
          var giftCardObj = personalize.giftcard_product;
          if(giftCardObj.length>0){
            for(var s=0;s<giftCardObj.length;s++){
              cartObject.push({
                id: giftCardObj[s],
                quantity: 1
              });
            }
          }
        }
      }
    }else{
        if(personalize.giftcard_product!=undefined && personalize.giftcard_product!=""){
        var giftCardObj = personalize.giftcard_product;
        if(giftCardObj.length>0){
          for(var s=0;s<giftCardObj.length;s++){
            cartObject.push({
              id: giftCardObj[s],
              quantity: 1
            });
          }
        }
      }
    }
  });
  if(cartObject.length>0){
    jQuery.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'POST',
      data: { 
        items: cartObject,
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname
      },
      success: function (cartdata) {
        jQuery('#upload-modal').find('.close_btn').trigger("click");
        
        cartDrawerObject.renderContents(cartdata);
        $(cartDrawerObject).removeClass("is-empty");
        jQuery('#CartDrawer').find('.drawer__header').show();
        jQuery('#CartDrawer-Form').show();
        closemodalPersonlize();
        loaderShowHide();
        jQuery("#add-to-cart").removeClass('loading');
        countdown("ten-countdown", timer_length, 0);
        jQuery("#add-to-cart").find('.loading__spinner').addClass('hidden');
      }
    });
  }
}

jQuery(document).on("click",".funnel_1_close,.funnel_2_close",function(){
  closemodalPersonlize();
  $('.backsteps-button').trigger('click');
   $('.common-steps').css({
      'transform': 'translateX(-0%)'
  });
});

function addMoreBracelet() {
    var clonedContent = jQuery('.modal--upload.active').find('.addmore-data-append').clone();
    var htmlString = clonedContent.find(".second-bracelet-name-image:last").html(); 
    var htmlObject = jQuery(htmlString); // Convert HTML string to a jQuery object

    var filePicker = htmlObject.find('.btn__file-picker.upload-file');
    htmlObject.find('.main-modal-product').hide();
    htmlObject.find('.engraving-text').hide();
    var autoIdFile = 0; // Initialize ID counter if not defined earlier
    if (filePicker.length) {
        autoIdFile = parseInt(filePicker.attr("data-id")) + 1; // Increment the `data-id`
        filePicker.attr("data-id", autoIdFile).attr("id", "upload-file-" + autoIdFile);
    }
 
    var inlineEditor = htmlObject.find('.inline-editor.joy-add-editor');
    if (inlineEditor.length) {
      inlineEditor.attr("id", "inline-editor-" + autoIdFile);
      inlineEditor.attr('data-src','');
      inlineEditor.attr('main-img','');
      inlineEditor.attr('crop-image','');
      inlineEditor.attr('blob-url','');
    }

    var countBracelet = htmlObject.find('.bracelet-name .number');
    if (countBracelet.length) {
        var getTextCount = jQuery(".modal--upload.active .second-bracelet-name-image:last").find('.bracelet-name .number').attr('data-count');
        if(jQuery(".modal--upload.active .second-bracelet-name-image:not('.remove-bracelet')").length==0){
          getTextCount=0;
        }
        getTextCount = (parseInt(getTextCount) + 1);
        var numberSet = getTextCount;
        if (getTextCount < 10) {
            getTextCount = '0' + getTextCount; // Ensure 2-digit format
        }
        countBracelet.text(getTextCount); // Update bracelet count
        jQuery(".modal--upload.active .second-bracelet-name-image:last").find('.bracelet-name .number').attr("data-count",numberSet);
        
        var countBraceletName = htmlObject.find('.bracelet-name .name');
        if (countBraceletName.length) {
            var suffix = getOrdinalSuffix(numberSet); // Get suffix (st, nd, rd, th)
            countBraceletName.text(numberSet + suffix + ' Bracelet'); // Update name with suffix
        }
    }

    var newBraceletWrapper = jQuery('<div class="second-bracelet-name-image" id="bracelet_'+autoIdFile+'"></div>').append(htmlObject);
    jQuery('.modal--upload.active').find('.addmore-data-append').append(newBraceletWrapper);
    jQuery('#inline-editor-' + autoIdFile).empty();
    jQuery("#upload-file-" + autoIdFile).parent('div').show();
  
    var funnelRepeat = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.select-bracelet-color.funnel-repeat');
    //console.log("funnelRepeat after add",funnelRepeat);
    if(funnelRepeat.length!=0){
      var getIndex = funnelRepeat.attr("data-repeat");
      getIndex = (parseInt(getIndex) + 1);
      //console.log("getIndex after add",getIndex);
      funnelRepeat.attr("data-repeat",getIndex);
      funnelRepeat.find('.color-variant.product-variant').removeClass('active');
      funnelRepeat.find('.color-variant.product-variant').eq(0).addClass('active');
    }

    jQuery('#bracelet_'+autoIdFile).find('.bracelet-image-text').hide();
  
    var countBracelet = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.bracelet-name .number');
    if (countBracelet.length) {
        var getTextCount = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.bracelet-name .number').attr('data-count');
        getTextCount = (parseInt(getTextCount) + 1);
        var numberSet = getTextCount;
        if (getTextCount < 10) {
            getTextCount = '0' + getTextCount; // Ensure 2-digit format
        }
        countBracelet.text(getTextCount); // Update bracelet count
        jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.bracelet-name .number').attr("data-count",numberSet);
        
        var countBraceletName = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.bracelet-name .name');
        if (countBraceletName.length) {
            var suffix = getOrdinalSuffix(numberSet); // Get suffix (st, nd, rd, th)
            countBraceletName.text(numberSet + suffix + ' Bracelet'); // Update name with suffix
        }
    }

    var editBracelet = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.edit_bracelet');
    if (editBracelet.length) {
        editBracelet.attr("id",'edit_'+getIndex);
        editBracelet.attr("data-edit",getIndex);
    }

    var deleteBracelet = jQuery(".modal--upload.active").find('#bracelet_'+autoIdFile).find('.delete_bracelet');
    if (deleteBracelet.length) {
        deleteBracelet.attr("id",'deletefunnel_'+getIndex);
        deleteBracelet.attr("funnel-delete",getIndex);
        deleteBracelet.attr("data-main",autoIdFile);
    }
    var changeIndex = (parseInt(autoIdFile-1));
    if(changeIndex==2){
      changeIndex = 1;
    }
    //console.log("changeIndex",changeIndex);
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.edit_bracelet').show();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.bracelet-image-text').show();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.upload-bracelet-photo').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.select-bracelet-color.funnel-repeat').hide();
    jQuery(".modal--upload.active").find('#bracelet_'+changeIndex).find('.main-custom-engraving').hide();

    jQuery(".modal--upload.active").find('.step-4.common-steps').find('#add-to-order').hide();
    jQuery(".modal--upload.active").find('.step-4.common-steps').find('#add-to-fourth-cart').show();
}

jQuery(document).on("click",".modal--upload.active .addmore_funnelbracelet",function(){
  addMoreFunnelBracelet();
});

function addMoreFunnelBracelet() {
    var clonedContent = jQuery('.modal--upload.active .addmore-data-append').clone();
    var htmlString = clonedContent.find(".second-bracelet-name-image:last").html();
    var htmlObject = jQuery(htmlString); // Convert HTML string to a jQuery object

    var filePicker = htmlObject.find('.btn__file-picker.upload-file');
    htmlObject.find('.main-modal-product').hide();
    htmlObject.find('.engraving-text').hide();
    var autoIdFile = 0; // Initialize ID counter if not defined earlier
    if (filePicker.length) {
        autoIdFile = parseInt(filePicker.attr("data-id")) + 1; // Increment the `data-id`
        filePicker.attr("data-id", autoIdFile).attr("id", "upload-file-" + autoIdFile);
    }

    var inlineEditor = htmlObject.find('.inline-editor.joy-add-editor');
    if (inlineEditor.length) {
        inlineEditor.attr("id", "inline-editor-" + autoIdFile);
    }

    var colorSelection = htmlObject.find('.select-bracelet-color.funnel-repeat');
    if (colorSelection.length) {
        var getIndex = colorSelection.attr("data-repeat");
        getIndex = (parseInt(getIndex) + 1);
        colorSelection.attr("data-repeat",getIndex);
        colorSelection.find('.color-variant.product-variant').removeClass('active');
        colorSelection.find('.color-variant.product-variant').eq(0).addClass('active');
    }
  
    var countBracelet = htmlObject.find('.bracelet-name .number');
    if (countBracelet.length) {
        var getTextCount = jQuery(".modal--upload.active .second-bracelet-name-image:last").find('.bracelet-name .number').attr('data-count');
        if(jQuery(".modal--upload.active .second-bracelet-name-image:not('.remove-bracelet')").length==0){
          getTextCount=0;
        }
        getTextCount = (parseInt(getTextCount) + 1);
        var numberSet = getTextCount;
        if (getTextCount < 10) {
            getTextCount = '0' + getTextCount; // Ensure 2-digit format
        }
        countBracelet.text(getTextCount); // Update bracelet count
        jQuery(".modal--upload.active .second-bracelet-name-image:last").find('.bracelet-name .number').attr("data-count",numberSet);
        
        var countBraceletName = htmlObject.find('.bracelet-name .name');
        if (countBraceletName.length) {
            var suffix = getOrdinalSuffix(numberSet); // Get suffix (st, nd, rd, th)
            countBraceletName.text(numberSet + suffix + ' Bracelet'); // Update name with suffix
        }
    }
    var newBraceletWrapper = jQuery('<div class="second-bracelet-name-image common-section-funnel" id="braceletfunnel_'+autoIdFile+'"></div>').append(htmlObject);
    jQuery('.modal--upload.active').find('.addmore-data-append').append(newBraceletWrapper);
    jQuery('#inline-editor-' + autoIdFile).html("");
    jQuery("#upload-file-" + autoIdFile).parent('div').show();
    var funnelRepeat = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.select-bracelet-color.funnel-repeat');
    if(funnelRepeat.length!=0){
      var getIndex = funnelRepeat.attr("data-repeat");
      getIndex = (parseInt(getIndex) + 1);
      funnelRepeat.attr("data-repeat",getIndex);
      funnelRepeat.find('.color-variant.product-variant').removeClass('active');
      funnelRepeat.find('.color-variant.product-variant').eq(0).addClass('active');
    }

    jQuery('#braceletfunnel_'+autoIdFile).find('.bracelet-image-text').hide();
  
    var countBracelet = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.bracelet-name .number');
    if (countBracelet.length) {
        var getTextCount = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.bracelet-name .number').attr('data-count');
        getTextCount = (parseInt(getTextCount) + 1);
        var numberSet = getTextCount;
        if (getTextCount < 10) {
            getTextCount = '0' + getTextCount; // Ensure 2-digit format
        }
        countBracelet.text(getTextCount); // Update bracelet count
        jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.bracelet-name .number').attr("data-count",numberSet);
        
        var countBraceletName = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.bracelet-name .name');
        if (countBraceletName.length) {
            var suffix = getOrdinalSuffix(numberSet); // Get suffix (st, nd, rd, th)
            countBraceletName.text(numberSet + suffix + ' Bracelet'); // Update name with suffix
        }
    }

    var deleteBracelet = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.bracelet-close');
    if (deleteBracelet.length) {
        deleteBracelet.attr("id",'deletefunnel_'+getIndex);
        deleteBracelet.attr("funnel-delete",getIndex);
        deleteBracelet.attr("data-main",autoIdFile);
    }

    var editBracelet = jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.edit_bracelet');
    if (editBracelet.length) {
        editBracelet.attr("id",'edit_'+getIndex);
        editBracelet.attr("data-edit",getIndex);
        editBracelet.attr("data-main",autoIdFile);
    }
    var changeIndex = (parseInt(autoIdFile-1));
    if(changeIndex==2){
      changeIndex = 1;
    }
    jQuery(".modal--upload.active").find('#braceletfunnel_'+autoIdFile).find('.modal-product-card.gift-card-products').removeClass("active-card");
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.edit_bracelet').show();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.bracelet-image-text').show();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.editfunnel_bracelet').show();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.upload-bracelet-photo').hide();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.select-bracelet-color.funnel-repeat').hide();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.funnel-2').hide();
    jQuery(".modal--upload.active").find('#braceletfunnel_'+changeIndex).find('.main-custom-engraving').hide();
    selectedDataFunnel2();
}

jQuery(document).on("click",".deletefunnel_bracelet",function(){
  var removeRepeatId = jQuery(this).attr("funnel-delete");
  var removeBraceletDiv = jQuery(this).attr("data-main");
  removeRepeatId=parseInt(removeRepeatId);
  personalizeData = personalizeData.filter(function(elem) {  
      //console.log("elem.data_repeat:", elem.data_repeat);
      return elem.data_repeat !== removeRepeatId; 
  }); 
  if(removeRepeatId==1){
    jQuery('#braceletfunnel_'+removeBraceletDiv).hide();
    jQuery('#braceletfunnel_'+removeBraceletDiv).addClass('remove-bracelet');
  }else{
    jQuery('#braceletfunnel_'+removeBraceletDiv).remove();
  }
  var getDeleteCount = jQuery('#delete_count').val();
  getDeleteCount = (parseInt(getDeleteCount)+1);
  jQuery('#delete_count').val(getDeleteCount);
  //console.log("remove afterpersonalizeData",personalizeData);
});

jQuery(document).on("click",".delete_bracelet",function(){
  var removeRepeatId = jQuery(this).attr("funnel-delete");
  var removeBraceletDiv = jQuery(this).attr("data-main");
  removeRepeatId=parseInt(removeRepeatId);
  personalizeData = personalizeData.filter(function(elem) {  
      //console.log("elem.data_repeat:", elem.data_repeat);
      return elem.data_repeat !== removeRepeatId; 
  });
  //console.log("personalizeData",personalizeData);
  if(jQuery('#bracelet_'+removeBraceletDiv).find('#inline-editor-'+removeBraceletDiv).attr('data-src')==""){
    jQuery('.step-4.common-steps').find('#add-to-fourth-cart').show();
    jQuery('.step-4.common-steps').find('#add-to-order').hide();
    jQuery('.step-4.common-steps').find('.addmore-sectionlink').show();
  }
  if(removeRepeatId==1){
    jQuery('#bracelet_'+removeBraceletDiv).hide();
    jQuery('#bracelet_'+removeBraceletDiv).addClass('remove-bracelet');
  }else{
    jQuery('#bracelet_'+removeBraceletDiv).remove();
  }
  var getDeleteCount = jQuery('#delete_count').val();
  getDeleteCount = (parseInt(getDeleteCount)+1);
  jQuery('#delete_count').val(getDeleteCount);
  //console.log("lenth check",jQuery(".modal--upload.active").find('.second-bracelet-name-image:not(".remove-bracelet")').length);
  if(jQuery(".modal--upload.active").find('.second-bracelet-name-image:not(".remove-bracelet")').length==0){
    jQuery(".modal--upload.active").find('.step-4.common-steps').find('.addmore-sectionlink').show();
  }
});

jQuery(document).on("keyup",".modal--upload.active .engraving_text_more",function(){
  //if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
    var getIndex = jQuery(this).parent().parent().parent().parent('div').find(".funnel-repeat").attr("data-repeat");
  //}
  if(jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button').hasClass('active-editmode')){
    getIndex = jQuery('.step-1.common-steps').find('.steps-next-btn.first-step-button.active-editmode').attr("data-edit");
  }
  if(getIndex==undefined){
    getIndex=0;
  }
  //console.log("get index",getIndex);
  getIndex=parseInt(getIndex);
  var checkval = checkKeyValue(personalizeData,'data_repeat',getIndex);
 
    var lengthRemove = jQuery("#delete_count").val();
    if(lengthRemove>0){
      lengthRemove = parseInt(lengthRemove);
      getIndex=(parseInt(getIndex)-lengthRemove);
    }
  //}
  if(checkval>0){
    personalizeData[checkval].engravingtext=jQuery(this).val();
  }else if(personalizeData[getIndex]!=undefined){
    personalizeData[getIndex].engravingtext=jQuery(this).val();
  }else{
    getIndex = parseInt(personalizeData.length-1);
    personalizeData[getIndex].engravingtext=jQuery(this).val();
  }
  //console.log("text personalizeData",personalizeData);
  jQuery('.engraving_textpreview').text(jQuery(this).val());
});

// Utility function to get the ordinal suffix for a number
function getOrdinalSuffix(number) {
    var j = number % 10, k = number % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
}

function closemodalPersonlize(){
  personalizeData=[];
  // jQuery('.common-steps').hide();
  // jQuery('.common-steps.step-1').show();
  if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
    jQuery('.modal--upload.popup-container-funnel.active').find('.modal-product-card.gift-card-products').removeClass('active-card');
  }else{
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.gift-add-ons-switch').removeClass('active-card');
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.gift-add-ons-switch').eq(0).addClass('active-card');
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.funnel-gift-boxs').removeClass('active-card');
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.funnel-gift-boxs').eq(0).addClass('active-card');
  }
  jQuery('.engraving_text_common').val('');
  jQuery('.engraving_textpreview').text('');
  jQuery('.main-custom-engraving').find('.engraving-text').hide();
  jQuery('.toggle--switch .switch-landing-noreverse').prop("checked",false);
  jQuery('.engraving-text').hide();
  //jQuery('.main-modal-product').hide();
  jQuery('.switch-funnel-popup').prop("checked",false);
  jQuery('.modal--upload.active').find('.steps-next-btn').removeClass("active-editmode");
  jQuery('.modal--upload.active').find('.steps-next-btn').removeAttr("funnel-edit");
  jQuery('.color-variant.product-variant').removeClass("active");
  if(jQuery('.step-2.common-steps.funnel-repeat').length>0){
    jQuery('.step-2.common-steps.funnel-repeat').find('.color-variant.product-variant').eq(0).addClass("active");
  }
  jQuery('.modal--upload.active').find('.step-3.common-steps').find('.backsteps-button.action-section').removeClass('back-repeat');
  jQuery('.step-4.common-steps .second-bracelet-name-image').removeClass("remove-bracelet");
  jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products').removeClass("active");
  //funnel 1 popup
  jQuery('.popup-container').css({
      'visibility': 'hidden',
      'opacity': '0',
      // 'transition': 'all 0.1s',
      'transform': 'scale(1.3)',
      'position': 'fixed'
  });
  //funnel 2 popup
  jQuery('.popup-container-funnel').css({
      'visibility': 'hidden',
      'opacity': '0',
      // 'transition': 'all 0.1s',
      'transform': 'scale(1.3)',
      'position': 'fixed'
  });
  jQuery('.section-header.shopify-section-group-header-group').css({'z-index': '3'});
  jQuery('body').css({'overflow': 'auto'});
  jQuery(".inline-editor").empty();
  jQuery('.inline-editor').html("");
  jQuery('#delete_count').val(0);
  jQuery('#add_moredata').val(0);
  var addIndex=0;
  if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
    jQuery('.modal--upload.popup-container-funnel.active').removeClass("addmore_funnelbracelet");
    jQuery('.main-bracelet-name-image .common-section-funnel').find('.engrave-text').text("-");
    jQuery('.main-bracelet-name-image .common-section-funnel').find('.selected-giftcard').html("-");
  }else if(jQuery('.modal--upload.popup-container.active').length>0){
    jQuery('.modal--upload.popup-container.active').removeClass("funnel-addmore");
    jQuery('.modal--upload.popup-container.active').find('.step-2.common-steps .select-bracelet-color.funnel-repeat').attr("data-repeat",0);
    jQuery('.modal--upload.popup-container.active').find('.step-4.common-steps .select-bracelet-color').eq(0).addClass("active");
  }
 jQuery('.modal--upload.active').find('.second-bracelet-name-image').each(function(){
    if(addIndex==0){
      jQuery(this).find('.bundle--checkbox').prop("checked",false);
      jQuery(this).find(".bracelet-image-text").hide();
      jQuery(this).find('.engraving-text').hide();
      jQuery(this).find('.engraving_text_common').val("");
      jQuery(this).find('.engraving_textpreview').text("");
      //jQuery(this).find('.modal-product-card.gift-card-products').removeClass("active-card");
      jQuery(this).find('.edit_bracelet').hide();
      jQuery(this).find('.bracelet-edit').hide();
      jQuery(this).find('.editfunnel_bracelet').hide();
      jQuery(this).find('.select-bracelet-color.funnel-repeat').show();
      jQuery(this).find(".upload-bracelet-photo").show();
      jQuery(this).find(".upload-bracelet-photo .upload-photo").show();
      jQuery(this).find('.funnel-2').show();
      jQuery(this).find(".inline-editor").html("");
      jQuery(this).find('.main-custom-engraving').show();
      jQuery(this).find(".color-variant.product-variant").eq(0).addClass("active");
    }else{
      jQuery(this).remove();
    }
    addIndex++;
  });
  jQuery('.funnel-step-4').find('.main-modal-product').hide();
  jQuery('.funnel-step-3').find('.main-modal-product').hide();
  if(jQuery('.modal--upload.popup-container-funnel.active').length>0){
    if(jQuery('.second-bracelet-name-image.common-section-funnel').find('.color-variant.product-variant').length > 0){
        jQuery('.second-bracelet-name-image.common-section-funnel').find('.color-variant.product-variant:first').addClass('active');
    } else {
        //console.log('No matching elements found.');
    }
  }
  jQuery('.modal--upload').removeClass("active");
  jQuery('form[data-type="add-to-cart-form"]')[0].reset();
  jQuery('body').removeClass('upload-popup-hidden');
  //jQuery('.step-4.common-steps').find('.addmore-sectionlink').hide();
  if(jQuery('#popup2').find('.btn__file-picker.upload-file').length>0){
      jQuery('#popup2').find('.btn__file-picker.upload-file').val('');
   }
}

function closeCartDrawer(){
  jQuery('body').removeClass("overflow-hidden").removeClass('overflow-hidden_mt');
  jQuery('body').removeAttr("style");
  jQuery('#CartDrawer').parent().removeClass('active');
}

function openCartDrawer(){
  jQuery('body').addClass("overflow-hidden").addClass('overflow-hidden_mt');
  jQuery('body').attr("overflow","auto;");
  jQuery('#CartDrawer').parent().addClass('active');
}
var currentStepIndex = 0;
function nextstepwiseShow(steps,interVals=''){
 
  if(interVals!=""){
    clearInterval(interVals);
  }
  steps = (parseInt(steps)+1);
  if(jQuery('.modal--upload.active').find('.step-'+steps+'.common-steps').length==0){
    if(steps==3){
      steps = (parseInt(steps)+1);
    }
  }

loaderShowHide();
$('.backsteps-button').show();
setTimeout(function(){

var $currentDot = $('.modal-header-dot.active');
var $nextDot = $currentDot.next('.modal-header-dot');
if ($nextDot.length) {
  $currentDot.removeClass('active');
  $nextDot.addClass('active');
}
// Handle common-steps_
var $currentStep = $('.common-steps_.active');

var $nextStep = $currentStep.next('.common-steps_');
  console.log($nextStep.html());
  var $steps = $('.common-steps_');
  var $currentStep = $steps.eq(currentStepIndex);
  var $nextStep = $steps.eq(currentStepIndex + 1);

  if ($nextStep.length) {
    $currentStep.removeClass('active');
    $nextStep.addClass('active');

    currentStepIndex++;
          $('.common-steps').css({
            'transform': 'translateX(-' + (currentStepIndex * 100) + '%)',
            'transition': 'transform 0.5s ease'
          });

  }

  jQuery(".steps-next-btn").removeClass('loading');
  jQuery(".steps-next-btn").find('.loading__spinner').addClass('hidden');
if ($('.step-3').hasClass('active')) {
  $('.step-3').closest('.modal__centered-content').addClass('new-class');
} else {
  $('.step-3').closest('.modal__centered-content').removeClass('new-class');
}
  // $('.steps-container').animate({ scrollTop: 0 }, 'slow');
  loaderShowHide();
}, 500);
  var attrcheck =jQuery('.modal--upload.active').find('.step-1.common-steps').attr("data-edit");
  if(attrcheck!=undefined && attrcheck !== false){
    var id=jQuery('.modal--upload.active').find('.step-1.common-steps').attr("data-edit");
    funnelOneEdit(id,steps);
  }
  if(steps==2){
    jQuery('.modal--upload.active').find('.modal__centered').addClass('scroll-modal');
  }else{
    jQuery('.modal--upload.active').find('.modal__centered').removeClass('scroll-modal');
  }
  if(steps==3){
    setTimeout(function(){
      sameBoxGift();
    },500);
  }
  //if(jQuery('.modal--upload.active').hasClass('popup-container-funnel')){
  if(steps==4){
    setTimeout(function(){
      sameBoxGiftFunnel();
      
    },500);
  }
  //}
}


// Define your Cloudinary details
const uploadPreset1 = 'upload_image'; // Replace with your actual upload preset
const cloudName1 = 'dxmczxqff'; // Replace with your actual Cloudinary cloud name

async function blobToCloudinaryupload(blobUrl) {
    try {
        // Fetch the blob from the URL
        const response = await fetch(blobUrl);
        const blob = await response.blob();

        // Create form data for Cloudinary
        const formData = new FormData();
        formData.append('file', blob);
        formData.append('folder', 'stanbarry_images'); // Your desired folder name
        formData.append('upload_preset', uploadPreset1);

        // Upload to Cloudinary
        const cloudinaryResponse = await fetch(`https://api.cloudinary.com/v1_1/${cloudName1}/image/upload`, {
            method: 'POST',
            body: formData
        });

        const data = await cloudinaryResponse.json();
        
        if (cloudinaryResponse.ok) {
            const uploadedImageUrl = data.secure_url;
            return uploadedImageUrl;
        } else {
            console.error('Cloudinary upload error:', data);
            return null;
        }
    } catch (error) {
        console.error('Error uploading image:', error);
        return null;
    }
}


jQuery(document).on("change",".modal--upload.active .switch-landing-noreverse",function(){
  if(jQuery(this).is(":checked")){
    jQuery(this).parent().parent().parent().parent().parent('div').find('.engraving-text').show();
    const modalBody = jQuery(".modal--upload.active").find('.modal__centered-content');
    if (modalBody.length) {
      modalBody.animate({
        scrollTop: modalBody.height() // Scroll to the bottom
      }, 500); // Adjust the animation speed (500ms) as needed
    }
  }else{
    jQuery(this).parent().parent().parent().parent().parent('div').find('.engraving-text').hide();
    jQuery('.modal--upload.active').find('.modal-footer').find('.error-msg').hide();
  }
});

jQuery(document).on("change",".modal--upload.active .switch-funnel-popup.funnel-engrave-text",function(){
  if(jQuery(this).is(":checked")==false){
    jQuery('.modal--upload.active').find('.modal-footer').find('.error-msg').hide();
  }else{
    const modalBody = jQuery(".modal--upload.active").find('.modal__centered-content');
    if (modalBody.length) {
      modalBody.animate({
        scrollTop: modalBody.height() // Scroll to the bottom
      }, 500); // Adjust the animation speed (500ms) as needed
    }
  }
});

//funnel 2 add ons change event start
jQuery(document).on("change",".modal--upload.active .bundle--checkbox.switch-funnel-popup.gift-add-ons-switch",function(){
  if(jQuery(this).is(":checked")){
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.gift-cards-list').eq(0).addClass('active-card');
  }else{
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.gift-cards-list').removeClass('active-card');
  }
  setTimeout(function(){
    giftCardSelected();
  },100);
});
//funnel 2 add ons change event end

//funnel 2 gift box change event start
jQuery(document).on("change",".modal--upload.active .bundle--checkbox.switch-funnel-popup.gift-boxes-switch",function(){
  if(jQuery(this).is(":checked")){
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.funnel-gift-boxs').eq(0).addClass('active-card');
  }else{
    jQuery('.modal--upload.active').find('.modal-product-card.gift-card-products.funnel-gift-boxs').removeClass('active-card');
  }
  setTimeout(function(){
    giftCardSelected();
  },100);
});
//funnel 2 gift box change event end
        
jQuery(document).on("click",".edit_bracelet.funnel-v1",function(){
  var editId = jQuery(this).attr("data-edit");
  editId = parseInt(editId);
  var getKey = checkKeyValue(personalizeData,'data_repeat',editId);
  if(getKey<0){
    getKey = 0;
  }
  funnelOneEdit(getKey,1);
  jQuery('.modal--upload.active').find('.steps-next-btn').addClass("active-editmode");
  jQuery('.modal--upload.active').find('.steps-next-btn').attr("data-edit",editId);
  jQuery('.modal--upload.active').find('.step-2.common-steps .select-bracelet-color.funnel-repeat').attr("data-repeat",getKey);
});

jQuery(document).on("click",".editfunnel_bracelet",function(){
  var editId = jQuery(this).attr("funnel-edit");
  if(editId==0){
    funnelTwoEdit(editId,1);
    jQuery('.modal--upload.active').find('.steps-next-btn').addClass("active-editmode");
    jQuery('.modal--upload.active').find('.steps-next-btn').attr("funnel-edit",editId);
  }else{
    var mainId = jQuery(this).parent().parent().parent().parent('div').attr("id");
    jQuery('#'+mainId).toggleClass("toggle-edit");
    toggleEditShowHide(mainId);
  }
});

function toggleEditShowHide(mainId){
  if(jQuery('#'+mainId).hasClass('toggle-edit')){
    jQuery('#'+mainId).find(".upload-bracelet-photo").show();
    jQuery('#'+mainId).find(".main-custom-engraving").show();
    jQuery('#'+mainId).find(".select-bracelet-color.funnel-repeat").show();
    jQuery(this).parent().parent().parent().parent('div').toggleClass("toggle-edit");
    jQuery('#'+mainId).find(".funnel-2").show();
  }else{
    jQuery('#'+mainId).find(".main-custom-engraving").hide();
    jQuery('#'+mainId).find(".upload-bracelet-photo").hide();
    jQuery('#'+mainId).find(".select-bracelet-color.funnel-repeat").hide();
    jQuery('#'+mainId).find(".funnel-2").hide();
    selectedDataFunnel2();
  }
}

function funnelTwoEdit(id,steps){
  var getPersonalize = personalizeData[id];
  var uploadImage = getPersonalize.default_image;
  var variant_image = getPersonalize.variant_image;
  var engravingText = getPersonalize.engravingtext;
  //console.log("getPersonalize",getPersonalize);
  var giftProducts = getPersonalize.giftcard_product;
  var variantId = getPersonalize.id;
  jQuery('#inline-editor-3').html("");
  //console.log("uploadImage",uploadImage);
  window.addPinturaEditor(uploadImage,'inline-editor-3');
  if(steps==1){
    jQuery('.modal--upload.active').find('.step-1.common-steps').show();
    jQuery('.modal--upload.active').find('.step-4.common-steps').hide();
  }
  if(engravingText!=""){
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.switch-funnel-popup').prop("checked",true);
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.engraving_text_common').val(engravingText);
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.engraving_textpreview').text(engravingText);
  }else{
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.switch-funnel-popup').prop("checked",false);
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.engraving_text_common').val("");
    jQuery('.modal--upload.active').find('.funnel-step-2').find('.engraving_textpreview').text("");
  }
  if(jQuery('.modal--upload.active').find('.funnel-step-3').find(".modal-product-card.gift-card-products.active-card").length!=0){
    jQuery('.modal--upload.active').find('.funnel-step-3').find('.main-modal-product').eq(0).show();
  }
  if(jQuery('.modal--upload.active').find('.funnel-step-4').find(".modal-product-card.gift-card-products.active-card").length!=0){
    jQuery('.modal--upload.active').find('.funnel-step-4').find('.main-modal-product').eq(0).show();
  }
}

function funnelOneEdit(id,steps){
  var getPersonalize = personalizeData[id];
  var uploadImage = getPersonalize.default_image;
  var variant_image = getPersonalize.variant_image;
  var crop_image = getPersonalize.crop_image;
  var engravingText = getPersonalize.engravingtext;
  //console.log("engravingText edfits",engravingText);
  var giftProducts = getPersonalize.giftcard_product;
  var variantId = getPersonalize.id;
  jQuery('#inline-editor-1').empty();
  window.addPinturaEditor(uploadImage,'inline-editor-1');
  if(steps==1){
    jQuery('.modal--upload.active').find('.step-1.common-steps').show();
    jQuery('.modal--upload.active').find('.step-4.common-steps').hide();
  }
  jQuery('.modal--upload.active').find('.step-2.common-steps').find('#merge-editor img').attr("src",variant_image);
  jQuery('.modal--upload.active').find('.step-2.common-steps').find('.color-variant.product-variant').removeClass("active");
  jQuery('.modal--upload.active').find('.step-2.common-steps').find('.color-variant.product-variant[data-vid="'+variantId+'"]').addClass("active");
  if(engravingText!=""){
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.switch-landing-noreverse').prop("checked",true);
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.engraving_text_common').val(engravingText);
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.engraving_textpreview').text(engravingText);
  }else{
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.switch-landing-noreverse').prop("checked",false);
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.engraving_text_common').val('');
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.engraving_textpreview').text('');
  }
  if(giftProducts!=undefined && giftProducts!=""){
    jQuery('.modal--upload.active').find('.step-2.common-steps').find('.modal-product-card.gift-card-products').removeClass("active");
    for(var f=0;f<giftProducts.lenght;f++){
      jQuery('.modal--upload.active').find('.step-2.common-steps').find('.modal-product-card.gift-card-products[data-vid="'+giftProducts[f]+'"]').addClass("active");
    }
  }
  
}

jQuery(document).on("change",".switch-funnel-popup",function(){
  var switchId = jQuery(this).attr("data-switch");
  if(jQuery(this).is(":checked")){
    //console.log("siwtch id",switchId);
    if(switchId==2){
      jQuery('.funnel-step-'+switchId).find('.engraving-text').show();
    }else{
      jQuery(this).parent().parent().parent().parent('div').find('.main-modal-product').show();
    }
    if(switchId==4){
      sameBoxGiftFunnel();
    }
  }else{
    if(switchId==2){
      jQuery('.funnel-step-'+switchId).find('.engraving-text').hide();
    }else{
      jQuery(this).parent().parent().parent().parent('div').find('.main-modal-product').hide();
    }
  }
  
});
function sameBoxGift(){
  var legthArr=[];
  jQuery('.step-3.common-steps').find('.modal-product-card.gift-card-products .product-name').each(function() {
    var height = jQuery(this).outerHeight();
    legthArr.push(height);
  });
  var maxValue = Math.max.apply(Math,legthArr);
  //console.log("maxValue",maxValue);
  maxValue = Math.round(maxValue);
  jQuery('.step-3.common-steps').find('.modal-product-card.gift-card-products .product-name').each(function() {
    jQuery(this).css('height',maxValue);
  });
}

function sameBoxGiftFunnel(){
  //if(jQuery('.funnel-step-4').find('.main-modal-product').attr('style')==""){
    var legthArr1=[];
    jQuery('.modal--upload.active').find('.funnel-gift-boxs .modal-product-image').removeAttr('style');
    jQuery('.modal--upload.active').find('.funnel-gift-boxs .product-name').removeAttr('style');
    if(jQuery('.funnel-step-4').find('.main-modal-product').attr('style')==""){
      jQuery('.modal--upload.active').find('.funnel-gift-boxs .modal-product-image').each(function() {
        var height = jQuery(this).outerHeight();
        legthArr1.push(height);
      });
      var maxValue = Math.max.apply(Math,legthArr1);
      maxValue = Math.round(maxValue);
      maxValue = parseInt(maxValue);
      jQuery('.modal--upload.active').find('.gift-card-products.funnel-gift-boxs .modal-product-image').each(function() {
        jQuery(this).css('height',maxValue);
      });
    }
    var legthArr=[];
    jQuery('.modal--upload.active').find('.gift-card-products.funnel-gift-boxs .product-name').each(function() {
      var height = jQuery(this).outerHeight();
      legthArr.push(height);
    });
    var maxValue = Math.max.apply(Math,legthArr);
    maxValue = Math.round(maxValue);
    maxValue = parseInt(maxValue);
    jQuery('.modal--upload.active').find('.gift-card-products.funnel-gift-boxs .product-name').each(function() {
      jQuery(this).css('height',maxValue);
    });
  //}
}
/********************** product details page photo upload personalization end  ************************/


/********************** product details page upsell product start  ************************/

jQuery(document).on("click",".addto_upsell",function(){
  var variantId = jQuery(this).attr("data-vid");
  var productId = jQuery(this).attr("data-pid");
  jQuery(".complete-collection").find('#pid_'+productId).hide();
  addUpsellCart(variantId);
});

setInterval(function(){
    getCarts();
},1000);

function upsellProductHideShow(){
  var totalUpsellCount = jQuery('#collect_product_count').val();
  var totalUpsellVisibleCount = 0;
  jQuery('.complete-collection').find('.product-card').each(function() {
    if(jQuery(this).css('display')=='none'){
       totalUpsellVisibleCount++;
    }
  });
  //console.log(".totalUpsellCount",totalUpsellCount,totalUpsellVisibleCount);
  if(totalUpsellCount==totalUpsellVisibleCount){
    jQuery('.complete-collection').hide();
  }else{
    jQuery('.complete-collection').show();
  }
}

//upsell product show when upsell product remove on cart drawer start 
jQuery(document).on("click",".cart-drawer .cart-remove-button",function(){
  var productId = jQuery(this).attr('data-pid');
  if(jQuery('.complete-collection').find('#pid_'+productId).length!=0){
    jQuery('.complete-collection').show();
    jQuery('.complete-collection').find('#pid_'+productId).show();
  }
});

jQuery(document).on("click",".cart-drawer .quantity__button_minus",function(){
  var inputval = jQuery(this).siblings('input').val();
  if(inputval==0){
    var productId = jQuery(this).siblings('input').attr('data-pid');
    jQuery('.cart-drawer').find('.cart-remove-button[data-pid="'+productId+'"]').trigger("click");
    if(jQuery('.complete-collection').find('#pid_'+productId).length!=0){
      setTimeout(function(){
        jQuery('.complete-collection').show();
        jQuery('.complete-collection').find('#pid_'+productId).show();
      },1000);
    }
  }
});
//upsell product show when upsell product remove on cart drawer end 
function getCarts(){
  jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      type: 'GET',
      success: function (cartdata) {
        if(cartdata.items.length>0){
          upsellProductHideShow();
          var itemdata = cartdata.items;
          itemdata.forEach((item) => {
            var productId = item.product_id;
            if(jQuery('.complete-collection').find('#pid_'+productId).length!=0){
              jQuery('.complete-collection').find('#pid_'+productId).hide();
            }
          });
        }
      }
  });
}

function addUpsellCart(variantId){
  if(variantId!=undefined && variantId!=""){
    loaderShowHide();
    jQuery.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'POST',
      data: { 
        id: variantId,
        quantity:1,
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname
      },
      success: function (cartdata) {
        cartDrawerObject.renderContents(cartdata);
        jQuery('#CartDrawer').find('.drawer__header').show();
        jQuery('#CartDrawer-Form').show();
        loaderShowHide(); 
      }
    });
  }
}


// Funnel 2 load for this commented code is enabled
/*jQuery(window).bind('load',function(){
  jQuery('.btn__file-picker.default-file-picker').addClass('funnelversion-two');
  jQuery('.btn__file-picker.default-file-picker').attr('data-id',3);
});*/
/********************** product details page upsell product end  ************************/
